/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import ControllerContainer from 'pages/dashboard/embeds/management/customize/controllercontainer/controllercontainer';
import { Title } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/propertycard/propertycard_styles';



/* ========== ~~~~~~~~~~ COMPONENT : PROPERTY CARD ~~~~~~~~~~ ========== */
const PropertyCard = (props) => {
    return (
        <div className={`propertycard ${props.classes.propertycard}`}>
            <ControllerContainer>
                <Title name={'cardtitle'}>
                    <h4>{props.title}</h4>
                </Title>
                <div className={'innerproperties'}>
                    {props.properties}
                </div>
            </ControllerContainer>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PropertyCard);
